<div>

  @if (dadosListaUsuarios) {
    <table class="table table-hover border-bottom">
      <caption>Tabela com lista de usuários referente ao pedido</caption>
      <thead>
        <tr>
          <th scope="col" class="border-top-0">MATRÍCULA</th>
          <th scope="col" class="border-top-0">BENEFICIÁRIO</th>
          <th scope="col" class="border-top-0">CPF</th>
          <th scope="col" class="border-top-0">CÓDIGO</th>
          <th scope="col" class="border-top-0">BENEFÍCIO</th>
          <th scope="col" class="border-top-0">QTDE.</th>
          <th scope="col" class="border-top-0">UNIT.</th>
          <th scope="col" class="border-top-0">TOTAL</th>
          <th scope="col" class="border-top-0">CARTÃO ATUAL</th>
          <th scope="col" class="border-top-0">SITUAÇÃO DO CRÉDITO</th>
        </tr>
      </thead>
      <tbody>
        <!-- LINHA 1 -->
        @for (usuario of dadosListaUsuarios | paginate: { id: 'paginacaoUsuarios',
          itemsPerPage: usuariosPorPagina,
          currentPage: paginaUsuarios,
          totalItems: $safeNavigationMigration(dadosListaUsuarios?.length) }; track usuario) {
          <tr>
            <td class="colunas-destaque">{{usuario.matricula}}</td>
            <td class="colunas-destaque">{{usuario.beneficiario | camelCase}}</td>
            <td class="colunas-destaque text-nowrap">{{usuario.cpf | cpf}}</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">{{beneficio.codigo}}</p>
            }</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">{{beneficio.beneficio}}</p>
            }</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">{{beneficio.quantidade}}</p>
            }</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">{{beneficio.valorUnitario}}</p>
            }</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">{{beneficio.subtotal}}</p>
            }</td>
            <!-- Validações para cada tipo de CARTÃO vem uma COR -->
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">
                @if (beneficio.cartaoAtual.includes('Alelo')) {
                  <span class="alelo">{{beneficio.cartaoAtual}}</span>
                }
                @if (beneficio.cartaoAtual.includes('Associado')) {
                  <span class="associado">{{beneficio.cartaoAtual}}</span>
                }
                @if (beneficio.cartaoAtual.includes('Devolvido')) {
                  <span class="devolvido">{{beneficio.cartaoAtual}}</span>
                }
                @if (beneficio.cartaoAtual.includes('Vale Papel')) {
                  <span class="vale-papel">{{beneficio.cartaoAtual}}</span>
                }
                @if (beneficio.cartaoAtual.includes('Novo')) {
                  <span class="novo">{{beneficio.cartaoAtual}}</span>
                }
                @if (!beneficio.cartaoAtual) {
                  <span>Em atualização</span>
                }
              </p>
            }</td>
            <td>@for (beneficio of usuario.beneficios; track beneficio) {
              <p [style.height]="usuario.beneficios.length>1 ? '70px' : 'auto'">
                @if (beneficio.situacaoCredito) {
                  <span>{{beneficio.situacaoCredito | camelCase}}</span>
                }
                @if (!beneficio.situacaoCredito) {
                  <span>Não consta</span>
                }
              </p>
            }</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (dadosListaUsuarios) {
    <div class="footer-card">
      <div>
        <app-select
          [value]="usuariosPorPagina"
          (valueChanges)="onUsuariosPorPaginaChange($event)"
          name="usuariosPorPaginaName"
                  [options]="[
                  {name : 'Exibir 3 por página' , value : '3'} ,
                  {name : 'Exibir 5 por página' , value : '5'} ,
                  {name : 'Exibir 7 por página' , value : '7'} ,
                  {name : 'Exibir 9 por página' , value : '9'}

                  ]"
          optionValue="value"
          optionText="name">
        </app-select>
      </div>
      <!-- Paginação CENTRAL -->
      <div>
        <pagination-controls class="my-pagination" id="paginacaoUsuarios" directionLink="true" (pageChange)="paginaUsuarios = $event" responsive="true" previousLabel="Anterior" nextLabel="Próxima"></pagination-controls>
      </div>
      <div>
        <p><span class="itens-pagina">{{dadosListaUsuarios.length}}</span> Registros foram encontrados</p>
      </div>
    </div>
  }

  @if (dadosListaUsuarios === null) {
    <div>
      <div class="text-center">
        <output class="spinner-border c-primary">
          <span class="visually-hidden">Consultando dados da lista de usuários ...</span>
        </output>
      </div>
      <p class="legenda-spinner">Consultando dados da lista de usuários ...</p>
    </div>
  }

  @if (dadosListaUsuarios === false) {
    <div class="text-center">
      <img src="/assets/img/erro.png" alt="representando erro na consulta dos usuários de pedidos" width="200px">
      <p class="legenda-erro">Ocorreu um erro na consulta dos usuários. Verifique se o número do pedido está correto..</p>
    </div>
  }
</div>
